import React from 'react';

import styled from 'styled-components';

import { useCommunityViewContext } from 'components/View/CommunityViewContext';
import { calculateCommunityDistance } from 'utils/data/communities';
import { getDistanceUnitLabel } from 'utils/helpers/units';

const Container = styled.div`
  font-size: 14px;
`;

interface Props {
  distance: number;
  dataTestId?: string;
}

const CMASummaryTableDataDistance = ({ distance, dataTestId }: Props) => {
  const { community } = useCommunityViewContext();
  const unit = getDistanceUnitLabel(community);

  return (
    <Container data-test-id={dataTestId}>
      {distance !== null && distance !== undefined ? `${calculateCommunityDistance(distance, community)} ${unit}` : '-'}
    </Container>
  );
};

export default CMASummaryTableDataDistance;
